export default class EstatedOtherArea {
  constructor(obj) {
    this.fips = obj.fips;
    this.apn = obj.apn;
    this.area_type = obj.area_type;
    this.area_sq_ft = obj.area_sq_ft;
  }
}
